define('pubsub/youtube',[
    'jquery',
    'underscore',
    '_pubsub'
], function($,_, Pubsub)
{
    'use strict';
    
    return function()
    {
        this.options={
            script:'https://www.youtube.com/iframe_api'
        };

        /**
         * @jira FDZ-629
         * holds all incoming create requests by key=id
         */
        this.oIncoming = {};
        this.aDone = [];
        
        var oPubsub=new Pubsub;
        
        this.init=function()
        {
                this.aVideo=[];
                oPubsub.on(Pubsub.CREATE_YOUTUBE_PLAYER, _.bind(this.triggerCeate,this));
                oPubsub.on(Pubsub.PLAY_VIDEO,_.bind(this.pauseAll,this));
                oPubsub.on(Pubsub.DISPOSE_YOUTUBE_PLAYER, _.bind(this.dispose,this));
        };
        
        /**
         * trigger create
         * store all incoming events and iterate through these since deferred is triggered once only if typeof YT==='undefined'
         * 
         * @jira FDZ-629
         * @updated 2023-02-14
         * @author sh@sopg.de
         * 
         * @param {object} ev 
         */
        this.triggerCeate=function(ev)
        {
            this.oIncoming[ev.data('id')] = ev;
            oPubsub.trigger(Pubsub.PLAY_VIDEO, ev.data('id'));
            this.require().then(_.bind(function() {
                _.each(this.oIncoming, _.bind(function(item) {
                    if(this.aDone.indexOf(item.data('id')) < 0) {
                        this.aDone.push(item.data('id'));
                        this.create(item);
                    }
                }, this));
            },this,ev));
        };

        /**
         * create player
         * 
         * @jira FDZ-597
         * @updated 2022-11-25
         * @author sh@sopg.de
         * 
         * @param {object} ev 
         */
        this.create=function(ev)
        {
            var id='yt-parent-' + ev.data('id'),
                    $el=$('<div/>', {
                        id:id,
                        'class':ev.data('class')
                    }).appendTo(ev);

            var oPlayer=new YT.Player(id, 
            {
                enablejsapi:true,
                videoId:ev.data('video-id'),
                playerVars:{
                    rel:0,
                    //@see FDZ-597: disable autoplay
                    autoplay: false
                }
            });
            oPlayer.addEventListener('onStateChange',_.bind(this.onStateChange,this, id));
            this.aVideo.push({
                id:id,
                data_id: ev.data('id'),
                player:oPlayer
            });
        };

        this.require=function()
        {
            var def=new $.Deferred();

            if(typeof YT==='undefined') {
                window.onYouTubeIframeAPIReady=def.resolve;

                $.getScript(this.options.script);
            } else {
                def.resolve();
            }

            return def.promise();
        };
        
        this.onStateChange=function(id, ev)
        {
            switch(ev.data) {
                case 1:
                    oPubsub.trigger(Pubsub.PLAY_VIDEO, id);
                    break;
                    
                default:break;
            }
        };
        
        this.pauseAll=function(id)
        {
            _.each(this.aVideo, _.bind(function(item){
                if(id!==item.id) {
                    this.pause(item);
                }
            },this));
        };
        
        this.pause=function(item)
        {
            if(typeof item.player.pauseVideo === 'function') {
                item.player.pauseVideo();
            }
        };
        
        this.broadcastPlay=function(id)
        {
            oPubsub.trigger(Pubsub.PLAY_VIDEO,id);
        };

        /**
         * dispose given video
         * 
         * @jira FDZ-682, FDZ-710
         * @date 2023-08-11
         * @updated 2023-10-06
         * @author sh@sopg.de
         * 
         * @param {object} $video
         */
        this.dispose = function($video)
        {
            const id = $video.find('iframe').attr('id');
            var iDelete = -1;

            _.each(this.aVideo, _.bind(function(item, index) {
                
                if(id === item.id) {
                    item.player.destroy();
                    delete this.oIncoming[item.data_id];
                    this.aDone.splice(this.aDone.indexOf(item.data_id), 1);

                    //provide current index, but splice AFTER _.each() iteration
                    iDelete = index;
                }
            },this));
            
            //@jira FDZ-710: splice after _.each() iteration
            if(iDelete >= 0) {
                this.aVideo.splice(iDelete, 1);
            }
        };

        this.init();
    }
});

